<template>
    <el-dialog :title="(customerChainId === null ? $t('common.create') : $t('common.update')) + ' ' + $t('shared.customerChain')" :visible.sync="showDialog" @open="loadCustomerChain" @close="closeDialog" width="500px" :close-on-click-modal="false">
        <el-form v-loading="loading" ref="form" :model="form" :rules="rules" size="small" label-width="160px" label-position="left">
            <el-form-item :label="$t('common.name')" prop="name">
                <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('masters.storeNumberRequired')" prop="storeNumberRequired">
                <el-switch v-model="form.storeNumberRequired"></el-switch>
            </el-form-item>

            <el-form-item v-for="(rule, index) in form.validationRules" :label="'Rule ' + (index+1)" :key="index" :prop="'validationRules.' + index + '.value'" :rules="{
      required: true, message: 'Rule can not be null', trigger: 'blur'
    }">
                <el-input v-model="rule.value">
                    <el-button slot="append" @click.prevent="removeRule(rule)" v-if="index > 0">{{$t('common.delete')}}</el-button>
                </el-input>
            </el-form-item>

            <el-form-item>
                <el-button :disabled="loading" @click="addRule" v-if="$isFullAdmin">{{$t('masters.addRule')}}</el-button>
                <el-button :disabled="loading" @click="save" type="primary" v-if="$isFullAdmin">{{customerChainId === null ? $t('common.create') : $t('common.update')}}</el-button>
                <el-button :disabled="loading" @click="closeDialog">{{$t('common.cancel')}}</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
    import api from '../api'

    export default {
        name: 'create-update-customer-chain-dialog',
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            customerChainId: {
                required: false
            }
        },
        data() {
            return {
                form: {
                    name: '',
                    storeNumberRequired: false,
                    validationRules: [
                        {
                            value: ''
                        }
                    ]
                },
                rules: {
                    name: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterName'),
                            trigger: 'blur'
                        }
                    ]
                },
                showDialog: this.visible,
                loading: false
            }
        },
        watch: {
            visible: function (val) {
                this.showDialog = val
            }
        },
        methods: {
            loadCustomerChain() {
                if (this.customerChainId) {
                    this.loading = true
                    api.getCustomerChain(this.customerChainId).then(response => {
                        this.loading = false
                        this.form.name = response.data.name
                        this.form.storeNumberRequired = response.data.storeNumberRequired
                        this.form.validationRules = response.data.validationRules.map(rule => { return { value: rule } })
                    })
                }
            },
            closeDialog() {
                this.$refs['form'].resetFields()
                this.showDialog = false
                this.loading = false
                this.$emit('dialogClosed')
            },
            addRule() {
                this.form.validationRules.push({ value: '' })
            },
            removeRule(rule) {
                this.form.validationRules = this.form.validationRules.filter(r => r !== rule)
            },
            save() {
                this.$refs['form'].validate(valid => {
                    if (valid) {
                        this.loading = true
                        api.saveCustomerChain(this.customerChainId, this.form).then(() => {
                            this.$emit('save', {
                                new: this.customerChainId === undefined,
                                id: this.customerChainId,
                                data: this.form
                            })
                            this.closeDialog()                            
                        })
                    } else {
                        return false
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ClientApp/app/masters/customerchains/components/CreateUpdateCustomerChainDialog.vue